import { RefObject, useCallback, useEffect } from 'react';

type RefType =
  | null
  | HTMLButtonElement
  | HTMLDivElement
  | HTMLInputElement
  | HTMLLabelElement
  | HTMLParagraphElement
  | HTMLSpanElement;

type RefArrayType = RefObject<RefType>[];

type RefsType = RefObject<RefType> | RefArrayType;

type EventHandlerType = (isInside: boolean) => void;

export default function useOutsideClick(
  refs: RefsType,
  handler: EventHandlerType
) {
  const handleClickOutside = useCallback(
    (e: MouseEvent | TouchEvent) => {
      if (refs && 'current' in refs && refs.current) {
        const isInside = Array.isArray(refs.current)
          ? refs.current.some(
              (element) => !!element && element.contains(e.target as Node)
            )
          : !!refs && !!refs.current && refs.current.contains(e.target as Node);

        handler(isInside);
      } else {
        const isInside =
          Array.isArray(refs) &&
          refs.some(
            (element) =>
              !!element &&
              !!element.current &&
              element.current.contains(e.target as Node)
          );

        handler(isInside);
      }
    },
    [handler, refs]
  );

  useEffect(() => {
    document.addEventListener('mouseup', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [handleClickOutside]);
}
